export default __webpack_public_path__ + "static/media/stateWave.47da2263.png";